module.exports = __webpack_public_path__ + "static/media/condition.584345c4.png";